import gql from "graphql-tag";

export const INFO = gql`
  query info {
    info {
      openHours {
        date
        intervals {
          start
          end
        }
      }
      languages {
        desc
        code
      }
      privacyPolicies {
        lang
        url
      }
      name
      desc
      logo
      phone
      email
      address {
        street
        postalCode
        city
        countryCode
        country
      }
    }
  }
`;

export const COMMON_INFO = gql`
  query commonInfo {
    commonInfo {
      unReadMessageCount
      pendingPayments
      currency
      knownCustomer
      contractMandatory
      unknownProductCode
      messages {
        messageCode
        messageTranslation
      }
    }
  }
`;

export const COUNTRIES = gql`
  query countries {
    countries {
      data {
        code
        desc
      }
      count
    }
  }
`;

export const CIVILITIES = gql`
  query civilities {
    civilities {
      data {
        code
        desc
        enterprise
      }
      count
    }
  }
`;

export const STATUS_INFO = gql`
  query statusInfo($where: StatusInfoWhereInput) {
    statusInfo(where: $where) {
      code
      desc
      color
      pageChunk
      documentation {
        description
        url
        docType
      }
    }
  }
`;
